<template>
  <div class="Header__Container">
    <div
      class="Header__Image"
      @click="BackHome()"
    />
    <div class="Header__Step">
      <div
        class="Header__StepNumber"
        :style="{ backgroundImage: `url(${GetStepImage()})`}"
      />
      <div class="Header__TextContainer">
        <p
          class="Header__TextParaB"
        >
          {{ $t(GetKey) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventBus } from '@/event-bus.js'

export default {
  computed: {
    ...mapGetters(['step']),
    GetKey () {
      switch (this.step) {
        case 0:
          return 'hint-home'
        case 1:
          return 'hint-shape'
        case 2:
          return 'hint-texture'
        case 3:
          return 'hint-save'
      }
      return ''
    }
  },
  methods: {
    GetStepImage () {
      switch (this.step) {
        case 0:
          return require('@/assets/t1.png')
        case 1:
          return require('@/assets/t2.png')
        case 2:
          return require('@/assets/t3.png')
        case 3:
          return require('@/assets/t4.png')
      }
    },
    BackHome () {
      EventBus.$emit('LogoClicked')
    }
  }
}
</script>

<style scoped lang="scss">
.Header__Container {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: flex-start;
  pointer-events: none;
  flex-direction: column;
}

.Header__TextContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: -2.5em;
  padding-top: 0px;
}

@media screen and (min-width: 1300px) {
  .Header__Step {
    margin-top: 1%;
    margin-left: auto;
    margin-right: auto;
    display : flex;
    flex-direction: row;
    width: 100%;
    height: auto;
    justify-content: center;
  }

  .Header__StepNumber {
    height: 6em;
    width: 6em;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .Header__TextParaA {
    margin-top: auto;
    margin-bottom: 0px;
    align-self: center;
    font-weight: 100;
        font-size: 1.5em;
  }

  .Header__TextParaB {
    margin-top: auto;
    margin-bottom: auto;
    align-self: center;
    font-weight: 400;
    font-size: 1.5em;
  }

  .Header__Text {
    height: 50%;
    font-weight: 100;
    font-size: 17px;
    display: flex;
    margin-left: -3.5em;
  }

  .Header__Image {
    margin-top: 55px;
    width: 100%;
    max-width: 30%;
    height: 3em;
    align-self: center;
    background-repeat: no-repeat;
    background-position: top;
    background-size: contain;
    background-image: url('../../assets/Roche_Logo.png');
    pointer-events: auto;
  }
}

@media screen and (max-width: 1300px) {
  .Header__Step {
    margin-top: 0.5%;
    margin-left: auto;
    margin-right: auto;
    display : flex;
    flex-direction: row;
    width: 100%;
    height: auto;
    justify-content: center;
  }

  .Header__StepNumber {
    height: 5.2em;
    width: 5.2em;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .Header__TextParaA {
    margin-top: auto;
    margin-bottom: 0px;
    align-self: center;
    font-weight: 100;
  }

  .Header__TextParaB {
    margin-top: auto;
    margin-bottom: auto;
    align-self: center;
    font-weight: 400;
  }

  .Header__Text {
    height: 50%;
    font-weight: 100;
    font-size: 17px;
    display: flex;
    margin-left: -45px;
  }

  .Header__Image {
    margin-top: 30px;
    width: 100%;
    max-width: 30%;
    height: 3em;
    align-self: center;
    background-repeat: no-repeat;
    background-position: top;
    background-size: contain;
    background-image: url('../../assets/Roche_Logo.png');
    pointer-events: auto;
  }

}

  .Header__Text_txt{
    font-weight: 200;
    font-size: 1.5em;
    font-weight: 400;
    align-self: center;
  }

  .Header__Text_step {
    margin-right: 0.2em;
    font-size: 3em;
    font-weight: 600;
    align-self: center;
  }
</style>
